import { render, staticRenderFns } from "./music_edit.vue?vue&type=template&id=3968074e&scoped=true&"
import script from "./music_edit.vue?vue&type=script&lang=js&"
export * from "./music_edit.vue?vue&type=script&lang=js&"
import style0 from "./music_edit.vue?vue&type=style&index=0&id=3968074e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3968074e",
  null
  
)

export default component.exports